var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-icon"},[(!_vm.isImageBlob)?_c('icon',{attrs:{"name":_vm.iconClass,"scale":"3"}}):_vm._e(),(_vm.isImageBlob)?_c('img',{attrs:{"src":_vm.blobUrl}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }